import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  IconButton,
  Snackbar as MaterialSnackbar,
} from "@mui/material";
import { useSubscription } from "observable-hooks";
import React, { useCallback, useState } from "react";

import { subjectSnackbar } from "../hooks/use-snackbar";

export default function Snackbar() {
  const [action, setAction] = useState();
  const [actionLabel, setActionLabel] = useState("Continue");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  useSubscription(
    subjectSnackbar,
    ({ message, action, actionLabel = "Continue" }) => {
      setMessage(message);
      setAction(() => action);
      setActionLabel(actionLabel);
      setOpen(true);
    }
  );

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const actionCall = useCallback(
    (event) => {
      if (!action) {
        return;
      }

      handleClose(event);
      action(event);
    },
    [action]
  );

  return (
    <MaterialSnackbar
      action={
        <React.Fragment>
          {action && (
            <Button color="secondary" onClick={actionCall} size="small">
              {actionLabel}
            </Button>
          )}
          <IconButton
            aria-label="close"
            color="inherit"
            onClick={handleClose}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      }
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      autoHideDuration={5000}
      message={message}
      onClose={handleClose}
      open={open}
    />
  );
}
